import { render, staticRenderFns } from "./MostrarCifradoPresupuestario.vue?vue&type=template&id=21ae0028&scoped=true"
import script from "./MostrarCifradoPresupuestario.vue?vue&type=script&lang=js"
export * from "./MostrarCifradoPresupuestario.vue?vue&type=script&lang=js"
import style0 from "./MostrarCifradoPresupuestario.vue?vue&type=style&index=0&id=21ae0028&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ae0028",
  null
  
)

export default component.exports